module.exports = __webpack_public_path__ + "static/media/NSS4.f0bc5996.jpg";